import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import {
  OlsConfigStore,
  RouteHandler
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

import CategoryLink from './CategoryLink';

function CategoriesDesktop(props) {
  const {
    Element: { ListItem }
  } = UX2;
  const { taxons, routePath, onClick, selectedTaxonPermalink, level = 1 } = props;

  const { position: allProductsIndex = 0 } = OlsConfigStore.getAllProductsInfo() || {};
  const defaultCategory = OlsConfigStore.getDefaultCategory();
  const shouldHighlightDefault =
    allProductsIndex !== 0 && routePath === RouteHandler.PRODUCTS_ROUTE && !selectedTaxonPermalink;

  const getSubcategoryPermalinks = taxon => {
    let subcategoryPermalinks = [];
    taxon.taxons.forEach(subTaxon => {
      if (subTaxon.taxons.length > 0) {
        subcategoryPermalinks = subcategoryPermalinks.concat(getSubcategoryPermalinks(subTaxon));
      }
      subcategoryPermalinks.push(subTaxon.permalink);
    });
    return subcategoryPermalinks;
  };

  const shouldShowSubcategories = taxon => {
    if (taxon.permalink === selectedTaxonPermalink) {
      return true;
    }

    const subcategoryPermalinks = getSubcategoryPermalinks(taxon);
    return subcategoryPermalinks.indexOf(selectedTaxonPermalink) > -1;
  };

  return taxons.map(taxon => {
    const isSelected = taxon.permalink === selectedTaxonPermalink;
    const highlightDefault = shouldHighlightDefault && taxon.permalink === defaultCategory;
    const isActive = isSelected || highlightDefault;

    return (
      <ListItem key={ taxon.id }>
        <CategoryLink
          name={ taxon.name }
          permalink={ taxon.permalink }
          isSelected={ isActive }
          onClick={ onClick }
        />
        { taxon.taxons.length > 0 && shouldShowSubcategories(taxon) && (
          <UX2.Element.List>
            { CategoriesDesktop({
              ...props,
              taxons: taxon.taxons,
              level: level + 1,
              separator: false
            }) }
          </UX2.Element.List>
        ) }
      </ListItem>
    );
  });
}

CategoriesDesktop.propTypes = {
  taxons: PropTypes.array,
  routePath: PropTypes.string,
  onClick: PropTypes.func,
  selectedTaxonPermalink: PropTypes.string,
  nested: PropTypes.bool,
  separator: PropTypes.bool
};

export default CategoriesDesktop;
